import { copyToClipboard } from "./general";

export {
  compareEvents,
  copySignupsArrayToClipboard,
}

function compareEvents( a, b ) {
  if ( a.startDT && b.startDT ) {
    if ( a.startDT < b.startDT ) {
      return -1;
    }
    if ( a.startDT > b.startDT ) {
      return 1;
    }
  }
  if ( a.endDT && b.endDT ) {
    if ( a.endDT < b.endDT ) {
      return -1;
    }
    if ( a.endDT > b.endDT ) {
      return 1;
    }
  }
  if ( a.date && b.date ) {
    if ( a.date < b.date ) {
      return -1;
    }
    if ( a.date > b.date ) {
      return 1;
    }
  }
  if ( a.time && b.time ) {
    if ( a.time < b.time ) {
      return -1;
    }
    if ( a.time > b.time ) {
      return 1;
    }
  }
  if ( a['.key'] < b['.key'] ) {
    return -1;
  }
  if ( a['.key'] > b['.key'] ) {
    return 1;
  }
  return 0;
}

function copySignupsArrayToClipboard( document, event, signupsarray, getSignupName ) {
  let signupstring = ''
  let separator = ','
  if( event.ctrlKey ) separator = '\r\n'

  for( let s of signupsarray ) {
    signupstring = signupstring + getSignupName( s ) + separator
  }
  // Remove the last separator
  if( signupstring.endsWith( separator ) ) {
    signupstring = signupstring.substr( 0, signupstring.length - separator.length )
  }

  copyToClipboard( document, signupstring )
}

